import { CrudModel } from "./_crud";

export class MediaAdminModel extends CrudModel {
	constructor() {
		super("admin/media");
	}
}

export default new MediaAdminModel();
